(function () {
	"use strict";

	angular.module("swurveys.maker")
		.controller("errorController", Handler);

    function Handler($scope, $routeParams) {

            $scope.errorMessagePage = $routeParams.message || "We are experiencing technical difficulties. We are sorry for the inconvenience and will be back up shortly.";

            };
}());
